import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { AccordionId } from '../../context/AccordionContext';
import { Benefit } from '../../types/insurance-report-api.types';
import { DEFAULT_ACCORDION_ID } from '../../utils/constants';
import { AccordionTable } from '../common-components/accordion-table';

interface FavoriteCDTCodesTableDataProps {
  accordionTitle: string;
  accordionId: AccordionId;
  data: Benefit[];
  onManageFavorites: () => void;
}

export const FavoriteCDTCodesTableData = ({
  accordionTitle,
  accordionId,
  data,
  onManageFavorites,
}: FavoriteCDTCodesTableDataProps) => {
  if (!data?.length) {
    return null;
  }
  return (
    <div css={{ marginBottom: theme.spacing(2) }}>
      <AccordionTable
        accordionTitle={accordionTitle}
        accordionId={accordionId || DEFAULT_ACCORDION_ID}
        data={data}
        customStyles={customStyles}
        customHeaderStyles={accordionHeaderStyles}
        customTableStyles={tableStyles}
        onManageFavorites={onManageFavorites}
        isFavoriteCDTTable
      />
    </div>
  );
};

const customStyles = css`
  border-radius: ${theme.borderRadius.medium};
  h3,
  button[aria-expanded='true'] {
    border-radius: ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0;
  }
  :has(button[aria-expanded='false']) {
    border: none;
  }
`;

const accordionHeaderStyles = css`
  border: 1px solid ${theme.colors.warning20};
  border-radius: ${theme.borderRadius.medium};
  background-color: ${theme.colors.warning5};
`;

const tableStyles = css`
  border-bottom-right-radius: ${theme.borderRadius.medium} !important;
  border-bottom-left-radius: ${theme.borderRadius.medium} !important;
`;
